import axios from "axios";

export async function getPresignedUrl(fileName) {
  if (!fileName) return null; // If no fileName, return null immediately

  try {
    const response = await axios.get(`https://api.parsr.in/users/getPresignedUrl?fileName=${fileName}`);
    
    if (response.data.url) {
      return response.data.url; // Return the signed URL
    } else {
      return null; // No URL found
    }
  } catch (error) {
    console.error("Error fetching PDF URL:", error);
    return null; // Return null on error
  }
}
